import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DummyBallIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 1.25C6.0723 1.25 1.25 6.0723 1.25 12C1.25 17.9277 6.0723 22.75 12 22.75C17.9277 22.75 22.75 17.9277 22.75 12C22.75 6.0723 17.9277 1.25 12 1.25ZM4.0534 16.7103C3.2311 15.3285 2.75 13.7213 2.75 12C2.75 6.8994 6.8994 2.75 12 2.75C13.7213 2.75 15.3286 3.2311 16.7103 4.0533C14.4836 4.2836 11.4753 5.9663 8.7207 8.7211C5.967 11.4748 4.2838 14.483 4.0534 16.7103ZM5.459 18.541C4.2173 17.2988 5.5156 13.3408 9.4278 9.4282C12.3609 6.4951 15.4024 5.0229 17.2247 5.0229C17.797 5.0229 18.2491 5.1684 18.5401 5.4589C19.1612 6.0805 19.1397 7.373 18.4796 9.0058C17.755 10.7997 16.3663 12.7763 14.5714 14.5712C10.7164 18.4257 6.6743 19.7588 5.459 18.541ZM12 21.25C10.2703 21.25 8.6558 20.7641 7.2697 19.9344C9.4995 19.7149 12.5134 18.0437 15.2784 15.2783C17.1661 13.3906 18.6329 11.2964 19.4063 9.3808C19.7098 8.6303 19.8918 7.936 19.9588 7.3096C20.7737 8.6869 21.2501 10.287 21.2501 11.9999C21.2501 17.1005 17.1006 21.25 12 21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

DummyBallIcon.displayName = 'DummyBallIcon';
